import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ThemeColors } from '../../web/components-v2/Theme/theme';
import { toSentenceCase } from '../../web/utils/toSentenceCase';

interface UseCreateTagCategoryMutationOptions {
	onSuccess?: (data: Api.ITagCategory) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

interface CreateTagsCategoryMutationParams {
	categoryName: string;
	expandTags?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	tags?: Api.IAccountTag[];
	color?: keyof ThemeColors['pill'];
}

export function useCreateTagCategoryMutation({ onSuccess, onError }: UseCreateTagCategoryMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({
			categoryName,
			impersonationContext,
			expandTags,
			tags = [],
			color,
		}: CreateTagsCategoryMutationParams) => {
			return userSession.webServiceHelper.callAsync<Api.ITagCategory>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tagcategory`,
					queryParams: {
						expand: expandTags ? 'Tags' : null,
					},
				}),
				'POST',
				{
					name: categoryName,
					color: toSentenceCase(color),
					tags,
				}
			);
		},
		onSuccess,
		onError,
	});
}
